import { Flex, Input } from "antd";
import { useState } from "react";

import ShareCampaignModal from "@features/ShareCampaignModalV2";
import { ExecutionStatusFilterEnum } from "@widgets/CampaignExecution/constants";
import { CampaignExecutionDropDown } from "@widgets/CampaignExecutionDropDown/index";
import { GanttChart, List, Search, Share } from "lucide-react";
import styles from "./CampaignExecutionFilters.module.scss";

interface CampaignBriefFiltersProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  // activeStatusFilter: ExecutionStatusFilter;
  // onStatusFilterChange: (filter: ExecutionStatusFilter) => void;
  actionPendingCount: number;
  completedCount: number;
  showPaymentColumns?: boolean;
  setShowPaymentColumns?: (show: boolean) => void;
  showDeclinedCreators?: boolean;
  setShowDeclinedCreators?: (show: boolean) => void;
  onAttachBrief?: () => void;
  onAttachScript?: () => void;
  viewMode?: "table" | "gantt";
  onViewModeChange?: (mode: "table" | "gantt") => void;
}

export function CampaignExecutionFilters({
  searchQuery,
  onSearchChange,
  // activeStatusFilter,
  // onStatusFilterChange,
  actionPendingCount,
  completedCount,
  showPaymentColumns,
  setShowPaymentColumns,
  showDeclinedCreators,
  setShowDeclinedCreators,
  onAttachBrief,
  onAttachScript,
  viewMode,
  onViewModeChange,
}: CampaignBriefFiltersProps) {
  const [openShareDrawer, setOpenShareDrawer] = useState<boolean>(false);

  const getStatusCount = (statusValue: string) => {
    if (statusValue === ExecutionStatusFilterEnum.ActionPending) {
      return actionPendingCount;
    } else if (statusValue === ExecutionStatusFilterEnum.Completed) {
      return completedCount;
    }
    return "";
  };

  return (
    <div style={{ width: "100%" }}>
      <Flex align="center" justify="space-between" style={{ width: "100%" }}>
        <div className={styles.filtersContainer}>
          <div className={styles.searchContainer}>
            <Input
              size="small"
              placeholder="Search by name,or handle"
              value={searchQuery}
              onChange={(e) => {
                onSearchChange(e.target.value);
              }}
              prefix={<Search size={16} className={styles.searchIcon} />}
              className={styles.searchInput}
            />
          </div>
          {/* <div className={styles.statusContainer}>
            <Segmented
              height={"33px"}
              size="middle"
              value={activeStatusFilter}
              onChange={(value) =>
                onStatusFilterChange(value as ExecutionStatusFilter)
              }
              options={Object.values(EXECUTION_STATUS).map((status) => {
                const count = getStatusCount(status.value);
                const isActionPending =
                  status.value === ExecutionStatusFilterEnum.ActionPending;
                const showNotificationDot =
                  isActionPending && actionPendingCount > 0;

                return {
                  label: (
                    <div
                      className={`${styles.segmentLabel} ${activeStatusFilter === status.value ? styles.selectedLabel : ""} ${showNotificationDot ? styles.segmentLabelWithDot : ""}`}
                    >
                      {status.label}
                      {isNumber(count) && (
                        <span
                          className={`${styles.statusBadge} ${activeStatusFilter === status.value ? styles.selected : ""}`}
                        >
                          {count}
                        </span>
                      )}
                      {showNotificationDot && (
                        <span className={styles.notificationDot}>
                          <span className={styles.notificationDotPing}></span>
                          <span className={styles.notificationDotCore}></span>
                        </span>
                      )}
                    </div>
                  ),

                  value: status.value,
                };
              })}
              className={styles.segmented}
            />
          </div> */}
        </div>

        <Flex align="center" gap={8}>
          {onViewModeChange && (
            <div
              className={styles.viewModeGroup}
              role="group"
              aria-label="Execution view"
            >
              <button
                type="button"
                onClick={() => onViewModeChange("table")}
                className={`${styles.viewModeBtn} ${
                  viewMode === "table" ? styles.viewModeBtnActive : ""
                }`}
                title="Table view"
              >
                <List size={14} />
                <span>Table</span>
              </button>
              <button
                type="button"
                onClick={() => onViewModeChange("gantt")}
                className={`${styles.viewModeBtn} ${
                  viewMode === "gantt" ? styles.viewModeBtnActive : ""
                }`}
                title="Milestone Chart"
              >
                <GanttChart size={14} />
                <span>Milestone Chart</span>
              </button>
            </div>
          )}

          <button
            className={styles.filterButton}
            onClick={() => setOpenShareDrawer(true)}
          >
            <Share size={14} />
            Share
          </button>

          <CampaignExecutionDropDown
            showPaymentColumns={showPaymentColumns}
            setShowPaymentColumns={setShowPaymentColumns}
            showDeclinedCreators={showDeclinedCreators}
            setShowDeclinedCreators={setShowDeclinedCreators}
            onAttachBrief={onAttachBrief}
            onAttachScript={onAttachScript}
          />
        </Flex>
      </Flex>
      <ShareCampaignModal
        isOpen={openShareDrawer}
        onClose={() => setOpenShareDrawer(false)}
        cards={["operations"]}
        width={500}
      />
    </div>
  );
}
